import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_confirm_fulfillment_order",
  ref: "confirmFulfillmentOrderRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-850px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_confirm_fulfillment_order_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "modal-body p-0" }
const _hoisted_10 = { style: {"min-height":"100px"} }
const _hoisted_11 = { class: "modal-footer flex-center" }
const _hoisted_12 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "indicator-label" }
const _hoisted_15 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_16 = { class: "indicator-progress" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.pleaseConfirm")), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createVNode(_component_el_form, {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_table, {
                    class: "mb-7",
                    data: _ctx.options.fulfilledItems,
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('order.image'),
                        width: "150"
                      }, {
                        default: _withCtx(({ row }) => [
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (_ctx.getProductIdData(row.sku_identifier)?.gallery)
                              ? (_openBlock(), _createBlock(_component_el_carousel, {
                                  key: 0,
                                  "indicator-position": "none",
                                  height: "100px",
                                  autoplay: false,
                                  arrow: "never"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductIdData(
                            row.sku_identifier
                          )?.gallery, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                        key: index,
                                        class: "d-flex justify-content-center align-items-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_image, {
                                            style: {"width":"100px","height":"100px","cursor":"pointer"},
                                            src: item.origin_url,
                                            fit: "contain",
                                            onClick: ($event: any) => (
                              _ctx.previewImages(
                                _ctx.getProductIdData(row.sku_identifier)?.gallery,
                                index
                              )
                            )
                                          }, null, 8, ["src", "onClick"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])), [
                            [_directive_loading, _ctx.options.loadingProducts]
                          ])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('order.articleInformation'),
                        width: "220"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.name_en), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.name), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.__show.brand_id), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.brand_article_no), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('order.articleAttributes'),
                        width: "220"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.t("order.size")) + ": " + _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.__show.size), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.t("order.color")) + ": " + _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.original_color), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('fulfillmentOrder.quantity'),
                        prop: "quantity",
                        width: "200"
                      }, {
                        default: _withCtx(({ row, $index }) => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.confirmed_items[$index].quantity,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.formData.confirmed_items[$index].quantity) = $event),
                            modelModifiers: { number: true },
                            type: "number",
                            step: "1",
                            min: 1,
                            max: row.quantity,
                            onInput: ($event: any) => (_ctx.quantityChange($event, $index))
                          }, {
                            append: _withCtx(() => [
                              _createTextVNode("/" + _toDisplayString(row.quantity), 1)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "max", "onInput"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["data"])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-light me-3",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
                }, [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
                ]),
                _createElementVNode("button", {
                  ref: "submitButton",
                  type: "submit",
                  class: "btn btn-lg btn-primary",
                  disabled: _ctx.isDisabledSubmit
                }, [
                  _createElementVNode("span", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_17
                  ])
                ], 8, _hoisted_13)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ], 512),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}